module.exports = __webpack_public_path__ + "img/bg1.aef34699.jpg";